import React from "react";
import { Container, Row, Card, Col } from "react-bootstrap";
import "./contact_us.css";

const ContactUs = () => {
  return (
    <>
      <Container style={{ marginTop: "50px" }} lg={10}>
        <h4>Contact us</h4>
        <Row style={{ width: "60rem", height: "60rem", margin: "3px" }}>
          <Col xs={12}>
            <Card>
              <Card.Body>
                <Card.Text>Sheik Halal Farms Inc.</Card.Text>
                <Card.Text>
                  12 Steinway Boulevard, unit 18, Etobicoke, ON, Canada, M9W 6M5
                </Card.Text>
                <Card.Text>Tel : 416-675-1736, 416-576-4814</Card.Text>
                <Card.Text>Fax : 905-828-4561</Card.Text>
                <Card.Text>
                  <iframe
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2881.9699927279944!2d-79.62228043521918!3d43.752719904008934!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x882b3b16c381eb89%3A0xefc84aa7c82a14bb!2sEtobicoke%2C%20ON%20M9W%206M5!5e0!3m2!1sen!2sca!4v1604279950853!5m2!1sen!2sca"
                    width="800"
                    height="600"
                    frameBorder="0"
                    style={{ border: "0" }}
                    aria-hidden="false"
                    title="Etobicoke store"
                  ></iframe>
                </Card.Text>
              </Card.Body>
            </Card>
          </Col>
        </Row>
        <Row style={{ width: "60rem", height: "60rem", margin: "3px" }}>
          <Col xs={12}>
            <Card>
              <Card.Body>
                <Card.Text>Grand Valley Plant.</Card.Text>
                <Card.Text>193064 Amaranth East Luther Townline</Card.Text>
                <Card.Text>Grand valley, Canada, ON, L9W0M3</Card.Text>
                <Card.Text>Tel: 416-576-4814, 905-828-5857</Card.Text>
                <Card.Text>Fax: 905-828-4561</Card.Text>
                <Card.Text>
                  <iframe
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2875.692021219865!2d-80.29972128521403!3d43.88293224556406!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x882bb1c7df0026f5%3A0xa4e7df9eaffaa4d1!2s193064%20Amaranth%20East%20Luther%20Townline%2C%20Grand%20Valley%2C%20ON%20L0N%201G0!5e0!3m2!1sen!2sca!4v1604280296923!5m2!1sen!2sca"
                    width="800"
                    height="600"
                    frameBorder="0"
                    style={{ border: "0" }}
                    aria-hidden="false"
                    title="Grand Valley Plant"
                  ></iframe>
                </Card.Text>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default ContactUs;
